import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  // ressource can be: user, code
  async loadQuotas (options) {
    return new Promise((resolve, reject) => {
      axiosInstance
        .get('quota/', options)
        .then((res) => {
          resolve(res.data.results)
        })
        .catch((err) => {
          reject(err)
        })
    })
  }
}
